var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('vue-headful',{attrs:{"title":'List2Go - ' + _vm.$t('title'),"description":"A trip, party or just shopping? List2Go is the easiest way to create a list together. Name it, add it, share it","lang":_vm.$t('lang')}}),_c('Home')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }